import $ from 'jquery';
import {showMoreJournal} from '../api/api';

export default class Journals {
	constructor(options) {
		const defaults = {
			el: '.js-journals',
			dom: {
				body: '.js-body',
				showMore: '.js-show-more',
				journalTmp: '.js-journal-tmp',
				container: '.js-journals-container'

			},
			classes: {
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {

		this.$showMore = this.$el.find(this.options.dom.showMore);
		this.$journalTmp = this.$el.find(this.options.dom.journalTmp).clone();
		this.$container = this.$el.find(this.options.dom.container);



		this.$el.find(this.options.dom.journalTmp).remove();
		return this;
	}

	showMore() {
		const data = {
			offset: this.currentCount,
			limit: this.step
		};

		showMoreJournal(data).then(resp => this.renderJournals(resp));

	}

	renderJournals(data) {
		let $cloneNode;
		data.items.forEach(item => {
			$cloneNode = this.$journalTmp.clone();
			$cloneNode.find('a').attr('href', item.href);
			$cloneNode.find('img').attr('src', item.src);
			this.$container.append($cloneNode);
		});
		this.currentCount += data.items.length;
		if (data.count <= this.currentCount) {
			this.$showMore.hide();
		}
	}



	render() {
		if (this.$el.length) {
			this.getDom();
			this.$showMore.on('click', e => this.showMore(e));
			this.currentCount = this.step = Number(this.$container.attr('data-step'));

		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/journals/journals.js
 **/